import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 100%;
  position: relative;
`

export const HeaderText = styled.h2`
  margin: 0 0 16px 0;
  color: #333;
  font-size: 18px;
`

export const CloseDiv = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background: #f5f5f5;
  }
`

export const CloseImg = styled.img`
  width: 16px;
  height: 16px;
`

export const ContentWrapper = styled.div`
  margin: 20px 0;
`

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
`

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: #0091d4;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
`

export const CancelButton = styled.button`
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`

export const SaveButton = styled.button`
  padding: 10px 20px;
  border: none;
  background: #0091d4;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: #007bb3;
  }
`